import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

const ScrollButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 1,
      behavior: "smooth",
    });
  };
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      window.onscroll = () => {
        const toTopBtn = document.getElementById("to-top");
        if (toTopBtn !== null) toTopBtn.setAttribute("style", "bottom:2em");
        if (window.scrollY < 333) {
          if (toTopBtn !== null) toTopBtn.setAttribute("style", "bottom:-3em");
        }
      };
    }
  }, []);

  return (
    <Button
      className="scroll-button"
      onClick={scrollToTop}
      title="Scroll to top"
      id="to-top"
    >
      <FontAwesomeIcon icon={faAngleUp} style={{ maxHeight: "42px" }} />
    </Button>
  );
};

export default ScrollButton;
